<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <br><br>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="6"
      >
        <div v-if="!text">
          <canvas
            id="myChart18"
            width="250"
            height="80"
          />
        </div>
        <div
          v-else
        >
          {{ text }}
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="6"
      >
        <v-row>
          <v-col
            v-if="valorRecebido"
            id="valorRecebidoId"
            class="text-right"
            cols="12"
            sm="10"
            md="10"
            lg="10"
            :style="styleObject"
          >
            {{ valorRecebido }}
          </v-col>
          <v-col
            cols="12"
            sm="1"
            md="1"
            lg="1"
          >
            <router-link
              to="/contas-receber/valor-recebido"
              :style="styleObject"
            >
              <v-icon
                id="iconLinkDetalheRecebido"
                class="text-left"
              >
                mdi-dots-vertical
              </v-icon>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import ContasReceber from '../../../../services/contasreceber'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardValorRecebido',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      myChart: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      primeiroDia: '',
      ultimoDia: '',
      empresa: [],
      selectClientes: [],
      enableGrafico: true,
      text: null,
      valorReceber: 0,
      valorRecebido: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      montaGrafico: true,
      percenteExibicao: null,
      loading: false,
      error: null,
      styleObject: {
        color: localStorage.corPrimaria,
      },
    }),

    created () {
      eventEmit.$on('set-valores-recebidos', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-valores-recebidos', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.empresa = select
        this.selectClientes = selectClientes

        this.MontarGrafico()
      },

      async MontarGrafico () {
        this.loading = true
        this.valorRecebido = null
        this.percenteExibicao = null

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await ContasReceber.showRelacaoValoresRecebidos(this.primeiroDia, this.ultimoDia, this.empresa, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.valorRecebido = resposta.data.valorRecebido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const porcentagemAtiginda = resposta.data.porcentagemAtiginda.toFixed(2)
            const porcentagemRestante = (100 - porcentagemAtiginda).toFixed(2)

            this.percenteExibicao = porcentagemAtiginda.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('myChart18').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [porcentagemAtiginda, porcentagemRestante],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                maintainAspectRatio: false,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: false,
                },
                elements: {
                  center: {
                    text: this.percenteExibicao,
                    color: '#000000',
                    fontStyle: 'bold',
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há valores à receber recebido no período selecionado') {
            this.text = resposta.data.mg

            this.valorRecebido = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.percenteExibicao = resposta.data.porcentagemAtiginda.toFixed(2).toString().replace('.', ',') + '%'

            this.error = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChart18 {
      width: 260px !important;
      height: 60px !important;
      margin: -3rem 0 0 -6rem;
    }

    #valorRecebidoCR {
      margin: 0 0 0 4.3rem !important;
    }

    #valorRecebidoId {
      font-size: 20px;
      display: grid;
      align-items: center;
      margin: -6.5rem 0 0 -4rem;
      font-weight: bold;
    }

    #iconLinkDetalheRecebido {
      margin: -10rem 0 0 18rem !important;
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart18 {
      width: 166px !important;
      height: 55px !important;
      margin: -7.5rem 0 0 33rem;
    }

    #valorRecebidoCR {
      margin: 0 0 0 37.5rem !important;
    }

    #valorRecebidoId {
      font-size: 20px;
      display: grid;
      align-items: center;
      margin: -7rem 0 0 29rem;
      font-weight: bold;
    }

    #iconLinkDetalheRecebido {
      margin: -3.75rem 0 0 43.4rem;
    }
  }

  @media screen and (min-width: 1380px) and (max-width: 1800px) {
    #myChart18 {
      margin: -3rem 0 0 0rem;
      height: 51px !important;
      width: 136px !important;
    }

    #valorRecebidoCR {
      font-size: 20px;
      margin: 0 0 0 5rem
    }

    #valorRecebidoId {
      margin: -2.5rem 0 0 -2rem
    }

    #iconLinkDetalheRecebido {
      margin: -2.5rem 0 0 0.5rem
    }
  }

  @media screen
  and (min-width: 1801px) {
    #myChart18 {
      margin: -3rem 0 0 6rem;
      width: 195px !important;
      height: 50px !important;
    }

    #valorRecebidoCR {
      font-size: 16px;
      margin: 0 0 0 10rem
    }

    #valorRecebidoId {
      margin: -2.5rem 0 0 0rem;
    }

    #iconLinkDetalheRecebido {
      margin: -2.5rem 0 0 -1rem
    }
  }
</style>

<style lang="sass">
  #myChart18
    margin: -3.5rem 0 0 0rem
    height: 51px !important
    width: 136px !important

  #valorRecebidoCR
    margin: 0rem 0 0 1.6rem
    font-weight: bold

  #valorRecebidoId
    font-size: 18px
    display: grid
    align-items: center
    margin: -3.5rem 0 0 -1.5rem
    font-weight: bold

  #carregaDadosContasRecebido
    font-size: 12px

  #iconLinkDetalheRecebido
    margin: -3.5rem 0 0 0.5rem
</style>
